<template>
  <b-container class="mt-4">
    <b-row>
      <b-col cols="12" lg="8">
        <List :api="myApi" />
      </b-col>
      <b-col cols="4" class="d-none d-lg-block">
        <Baruun />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Baruun from "./global/Baruun";
import List from "./global/List";
import { getHash } from "./../api";

export default {
  data() {
    return {
      myApi: getHash
    };
  },
  components: {
    Baruun,
    List
  }
};
</script>
